import React from 'react';
import { motion } from 'framer-motion';

interface AiPresetButtonProps {
  title: string;
  onClick: () => void;
  disabled?: boolean;
}

export const AiPresetButton: React.FC<AiPresetButtonProps> = ({
  title,
  onClick,
  disabled = false
}) => {
  return (
    <motion.button
      whileHover={!disabled ? { scale: 1.01, y: -1 } : {}}
      whileTap={!disabled ? { scale: 0.98 } : {}}
      transition={{ duration: 0.2, ease: [0.25, 0.1, 0.25, 1] }}
      onClick={onClick}
      disabled={disabled}
      className="w-full text-left px-4 py-3.5 rounded-2xl transition-all duration-300"
      style={{
        background: 'linear-gradient(145deg, rgba(20,20,22,0.95) 0%, rgba(14,14,16,0.98) 100%)',
        border: '1px solid rgba(255,255,255,0.06)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.05), inset 0 -2px 4px rgba(0,0,0,0.3)',
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer'
      }}
    >
      <div className="flex items-start gap-3">
        <div 
          className="flex-shrink-0 w-1.5 h-1.5 rounded-full mt-2"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.4) 100%)',
            boxShadow: '0 0 8px rgba(255,255,255,0.3)'
          }}
        />
        <p 
          className="text-[15px] leading-relaxed font-normal"
          style={{
            color: 'rgba(255,255,255,0.85)',
            textShadow: '0 1px 2px rgba(0,0,0,0.3)'
          }}
        >
          {title}
        </p>
      </div>
    </motion.button>
  );
};
